import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { ProviderService } from '../../../service/provider.service';

@Component({
  selector: 'app-technical-agreement',
  templateUrl: './technical-agreement.component.html',
  styleUrls: ['./technical-agreement.component.less']
})
export class TechnicalAgreementComponent implements OnInit {

  @Input() code = 0;
  @Input() pno: any;
  @Input() taid: any;
  providers = [];
  validateForm: FormGroup;
  uploadFileList: any[] = [];
  filePathList: any[] = [];
  fileType = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'img'];
  constructor(
    private customValidatorService: CustomValidatorService,
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
    this.validateForm = this.fb.group({
      taName: [null, [Validators.required]], // 协议名称
      taNo: [null, [Validators.required]], // 协议编号
      pno: [this.pno, [Validators.required]], // 协议编号
      taContent: [null], // 协议内容
      aSigner: [null], // 甲方代表姓名
      aSignerPhone: [null], // 甲方代表电话
      bSigner: [null], // 乙方代表姓名
      bSignerPhone: [null], // 乙方代表电话
      signDate: [null], // 签订日期
      mark: [null] // 备注
    });
    if (this.code === 1 || this.code === 2){
      this.providerService.getTechnicalAgreement(this.taid).subscribe((data: any) => {
        if ( !this.isEmpty(data) ){
          this.setValidateForm(data);
          const fList = [];
          if (!this.isEmpty(data.filePaths)){
            data.filePaths.forEach(element => {
              let fileNode = new FileNode();
              fileNode = {
                uid: element.id,
                name: element.name,
                url:  element.url,
                status: 'done',
                showDownload: false,
                type: element.type,
                response: { code: 200, data: { url: element.url } },
                iconType: '',
                isImageUrl: false,
                isUploading: false,
                linkProps: undefined,
                message: ''
              };
              fList.push(fileNode);
            });
          }
          this.uploadFileList = fList;
          if (this.code === 2){
            this.validateForm.disable();
          }
        }
      });
    }
    this.providers = await this.providerService.getProviderList();
  }
  getTaForm(){
    return this.validateForm;
  }
  getFilePathList(){
    this.filePathList = [];
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.forEach(element => {
        if (element.response.code === 200) {
          if (this.fileType.some(e => e === element.type)) {
            element.type = 'img';
          } else {
            element.type = 'txt';
          }
          const node = {
            name: element.name,
            url: element.response.data.url,
            type: element.type
          };
          this.filePathList.push(node);
        }
      });
    } else {
      this.filePathList = [];
    }
    return this.filePathList;
  }
  async  handleChange({ file, fileList }: NzUploadChangeParam) {
    if (file.status === 'uploading') {
      return;
    }
    let fList = fileList;
    fList = fList.map(fe => {
      if (fe.response.code === 200) {
        // Component will show file.url as link
        fe.url = 'attachmentServer' + fe.response.data.url;
      }
      return fe;
    });
    this.uploadFileList = fList;
    console.log(this.uploadFileList);
  }

  removeFile = (file: NzUploadFile) => {
    if (this.code === 2) {
      return false;
    } else {
      return true;
    }
  }
  setValidateForm(quotationSheet: any){
    this.validateForm.get('taName').setValue(!this.isEmpty(quotationSheet.taName) ? quotationSheet.taName : null);
    this.validateForm.get('taNo').setValue(!this.isEmpty(quotationSheet.taNo) ? quotationSheet.taNo : null);
    this.validateForm.get('pno').setValue(!this.isEmpty(quotationSheet.pno) ? quotationSheet.pno : null);
    this.validateForm.get('taContent').setValue(!this.isEmpty(quotationSheet.taContent) ? quotationSheet.taContent : null);
    this.validateForm.get('aSigner').setValue(!this.isEmpty(quotationSheet.aSigner) ? quotationSheet.aSigner : null);
    this.validateForm.get('aSignerPhone').setValue(!this.isEmpty(quotationSheet.aSignerPhone) ? quotationSheet.aSignerPhone : null);
    this.validateForm.get('bSigner').setValue(!this.isEmpty(quotationSheet.bSigner) ? quotationSheet.bSigner : null);
    this.validateForm.get('bSignerPhone').setValue(!this.isEmpty(quotationSheet.bSignerPhone) ? quotationSheet.bSignerPhone : null);
    this.validateForm.get('signDate').setValue(!this.isEmpty(quotationSheet.signDate) ? quotationSheet.signDate : null);
    this.validateForm.get('mark').setValue(!this.isEmpty(quotationSheet.mark) ? quotationSheet.mark : null);
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
class FileNode implements NzUploadFile {
  uid: string;
  name: string;
  [key: string]: any;
}

